module.exports = __webpack_public_path__ + "static/media/umap.90b14c88.png";